<mat-form-field
  appearance="outline" 
  [hideRequiredMarker]="true"
  [formGroup]="group"
  class="nsc-form-field-select"
  subscriptSizing="dynamic"
  [attr.data-label]="placeholder"
>
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select
    #selectRef
    [id]="idx"
    [formControlName]="controlName"
    (openedChange)="onPanelOpenedChange($event, selectRef)"
    (selectionChange)="changeValue($event)">

    <!-- obj.xpathCode is configured only in one scenario where custom xpath is required in all other scenarios i will be used for generating xpath-->

    @for (obj of selectObjects; track obj; let i = $index) {
      <mat-option
        id = "{{idx}}_{{obj.xpathCode || i}}"
        [value]="obj.value"
        [attr.aria-label]="obj.value === group.controls[controlName].value ? obj.name + ' selected' : null">
        {{ obj.name }}
      </mat-option>
    }
  </mat-select>
  <mat-hint aria-live="off">{{ content.hint }} </mat-hint>
  @if (group.controls[controlName].invalid) {
    <mat-error>Error: {{ content.hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
  }
</mat-form-field>
<div class="cdk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">
  {{ panelStatusAnnouncement }}
</div>